module.exports = __webpack_public_path__ + "img/dashboard.c24287bd.svg";